export const EManualExternalOrderSourceType = {
  PrimaryMarketplace: 0,
  SecondaryMarketplace: 1,
  WhatsApp: 2,
  Instagram: 3,
  Phone: 4,
  ExternalCounter: 5,
  Other: 6,
  PartnerApp: 7,
  DeliveryMarketplace: 8,
  PartnerMarketplace: 9,
  DeliveryPlatform: 10,
  OrderPlatform: 11,
  ExternalAutomation: 12,
  CatalogWeb: 13,
  DirectDelivery: 14,
  PartnerCatalog: 15,
  PartnerShowcase: 16,
  PartnerSalesSystem: 17,
  CommercePlatform: 18,
  PartnerManagementSystem: 19,
  Linx: 20,
  Totvs: 21,
  PartnerPos: 22,
  ServicePlatform: 23,
  LocalDeliveryPlatform: 24,
  RegionalMarketplace: 25,
  PromotionalChannel: 26,
  PartnerSalesChannel: 27,
  OwnDigitalCatalog: 28,
  OwnWebsite: 29,
  Facebook: 30,
  Telegram: 31,
  Email: 32,
  OwnApp: 33,
} as const

export type EManualExternalOrderSourceType =
  (typeof EManualExternalOrderSourceType)[keyof typeof EManualExternalOrderSourceType]
